import { useState } from 'react'
import { Form, Input, Button, Card, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { authAPI } from '../../api'
import { setToken, setUserInfo } from '../../utils/auth'
import './index.css'

const Login = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  // 获取登录前的来源地址
  const from = (location.state as any)?.from || '/dashboard'

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true)
    try {
      // 密码只在请求中传输，不做任何持久化存储，也不打印日志
      const res = await authAPI.login(values)
      if (res.code === 200) {
        // Token 加密存储
        const expireHours = parseInt(
          process.env.REACT_APP_TOKEN_EXPIRE_HOURS || '24',
          10
        )
        setToken(res.data.token, expireHours)
        setUserInfo(res.data.user)
        message.success('登录成功')
        // 跳转到来源页面或首页
        navigate(from, { replace: true })
      }
    } catch (error) {
      // 错误已在拦截器处理
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <Card className="login-card" title="伴成商城管理后台">
        <Form onFinish={onFinish}>
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3位' },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="用户名" size="large" autoComplete="username" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              size="large"
              autoComplete="current-password"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default Login
